import { useEffect, useState } from "react";
import { SEARCH_DEBOUNCE_MS, useAutocomplete } from "../../providers/AutocompleteProvider";
import {useConfigContext} from "../../../ConfigProvider.tsx";
import { Panel } from "../Panel/Panel";

export function InformationResults() {
    const {
        autocompleteState: { query },
    } = useAutocomplete();
    const {
        tc,
        searchClient,
        indexPrefix,
    } = useConfigContext()

    const [totalInfoCount, setTotalInfoCount] = useState(0);

    useEffect(() => {
        if (!query) {
            setTotalInfoCount(0);
            return;
        }
        const indexName = [
            indexPrefix,
            'IFU_DEU_content_crawler_pages'
        ]
            .filter((s) => s && s.length)
            .join('_')

        // Same debounce as the autocomplete sources: this counting request is fired
        // from the same input, so it must not run on every keystroke either.
        const timeout = setTimeout(() => {
            searchClient
                .search([
                    {
                        indexName,
                        params: {
                            query,
                            hitsPerPage: 0,
                        },
                    },
                ])
                .then(({ results }) => {
                    setTotalInfoCount((results[0] as any).nbHits);
                })
                .catch(() => {
                    setTotalInfoCount(0);
                });
        }, SEARCH_DEBOUNCE_MS);

        return () => clearTimeout(timeout);
    }, [query, searchClient, indexPrefix]);

    if (!query || totalInfoCount === 0) return null;

    const url = `/de/search/?input_search=${encodeURIComponent(query)}#information`;

    return (
        <Panel title={tc.information || tc.search}>
            <div className="aa-InformationLink">
                <a href={url}>
                    {totalInfoCount} {tc.showAllInformation}
                </a>
            </div>
        </Panel>
    );
}
